var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7245 0.616847C20.1993 0.0727075 19.422 -0.130011 18.6972 0.0833769L1.79578 5.04465C1.03107 5.2591 0.489044 5.87473 0.343034 6.65679C0.193873 7.45273 0.714887 8.46312 1.39557 8.88563L6.68028 12.1643C7.2223 12.5004 7.92189 12.4161 8.37042 11.9595L14.4219 5.81284C14.7266 5.49276 15.2308 5.49276 15.5354 5.81284C15.84 6.12226 15.84 6.62372 15.5354 6.9438L9.47337 13.0915C9.02379 13.5471 8.93975 14.2566 9.27064 14.8071L12.4997 20.1952C12.8778 20.8354 13.5291 21.1981 14.2434 21.1981C14.3274 21.1981 14.4219 21.1981 14.506 21.1874C15.3253 21.0808 15.9766 20.5153 16.2182 19.7151L21.2287 2.67604C21.4493 1.95052 21.2497 1.16099 20.7245 0.616847Z",
    fill: "white",
    fillOpacity: 0.95
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.1aad6af7361e942a46067d18c6027b12.svg";
export { ForwardRef as ReactComponent };